import { useState } from 'react';
import Select from 'react-select';
import { useTheme } from 'styled-components';
import {
  getSelectStyles,
  DisabledWrapper,
  DisabledTooltipBubble,
} from './InputSelect.styled';

const InputSelect = ({ options, value, onChange, isDisabled, disabledReason }) => {
  const theme = useTheme();
  const styles = getSelectStyles(theme);
  const [hovered, setHovered] = useState(false);

  const selectedOption = options.find((opt) => opt.value === value) || null;

  const select = (
    <Select
      options={options}
      value={selectedOption}
      onChange={onChange}
      styles={styles}
      isSearchable={false}
      isDisabled={isDisabled}
    />
  );

  if (isDisabled && disabledReason) {
    return (
      <DisabledWrapper
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {select}
        <DisabledTooltipBubble $show={hovered}>{disabledReason}</DisabledTooltipBubble>
      </DisabledWrapper>
    );
  }

  return select;
};

export default InputSelect;
